import React from 'react';
import UserStats from '../../components/users/UserStats';
import FilterBar from '../../components/filters/FilterBar';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { useFilterPersistence } from '../../hooks/useFilterPersistence';
import { PAGE_INFO, FILTER_PERIODS } from '../../constants';
import './Users.css';

/**
 * Users Page Component
 * User management and statistics overview
 */
const Users = () => {
  const { period, setPeriod, platform, setPlatform } = useFilterPersistence({
    pageKey: 'users',
    defaultPeriod: FILTER_PERIODS.ALL, // Default to "All Time"
    defaultPlatform: null // Default to "All Platforms"
  });

  const filters = (
    <FilterBar
      period={period}
      onPeriodChange={setPeriod}
      platform={platform}
      onPlatformChange={setPlatform}
    />
  );

  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.USERS.title}
        description={PAGE_INFO.USERS.description}
        filters={filters}
      >
        <div className="users-content">
          <UserStats period={period} platform={platform} />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Users;
